import Measurer from './Measurer';
import { update } from 'Emitter';
import * as ViewModes from 'Enum/ViewModes';
import { UI, MEASUREMENT } from 'StateEvents';
import * as VPAIDEvents from 'Enum/VPAIDEvents';
import { lastItem, count } from 'Services/Misc/collections';

export default class InteractionMeasurer extends Measurer {
  constructor() {
    super();
  }

  onUpdate(nextState, prevState, changes) {
    super.onUpdate(nextState, prevState, changes);

    if(this.adClicked(changes)) {
      this.queueRequests(nextState.configuration.Events.click, MEASUREMENT.CLICKED);
    }

    if(changes.media && changes.media.skipped) {
      this.queueRequests(nextState.configuration.Events.skip, MEASUREMENT.SKIPPED);
    }

    if(changes.display && changes.display.shares) {
      this.queueRequests(
        nextState.configuration.Events.share,
        MEASUREMENT.SHARED, {
          macros: {
            SHARE_CODE: lastItem(nextState.display.shares)
          }
        }
      );
    }

    if(changes.display && changes.display.viewMode && nextState.display.viewMode === ViewModes.FULLSCREEN) {
      this.queueRequests(nextState.configuration.Events.fullscreen, MEASUREMENT.FULLSCREEN);
    }
  }

  adClicked(changes) {
    return changes.display && changes.display.clicks;
  }
}


// WEBPACK FOOTER //
// ./src/Services/Measurement/InteractionMeasurer.js